<template>
  <div class="cdu-page">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'CduLayout',

    components: {

    }
  }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/CduLayout.vue